var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"p-2"},[(_vm.showChart)?_c('line-chart',{staticClass:"pb-3 holdings-breakdown-chart",attrs:{"chartData":_vm.chartData,"chartOptions":_vm.chartOptions}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }